import PropTypes from 'prop-types'
import styled from 'styled-components'
import { withTranslation } from 'react-i18next'
import colors from 'components/utils/colors'

import Button from 'components/Shared/Button/Index'

const StyledWrapper = styled.div`
  display: flex;
  flex: 1 100%;
  padding: 48px 16px;
  box-sizing: border-box;
  border: 1px solid ${colors.secondary95};
  border-top: none;
`

const StyledPrimaryButton = styled(Button)`
`

const StyledSecondaryButton = styled(Button)`
  margin-left: 8px;
`

const AdditionalButtonWrapper = styled.div`
  margin-right: 8px;
`

const Spacer = styled.div`
  flex: 1;
`

const TableFormButtons = ({ primaryButton, secondaryButton, additionalButton, className, t }) => {
  return (
    <StyledWrapper className={className}>
      {!!additionalButton && (
        <AdditionalButtonWrapper>
          {additionalButton}
        </AdditionalButtonWrapper>
      )}

      <Spacer />

      <StyledPrimaryButton
        large
        disabled={primaryButton.disabled}
        type='submit'
        onClick={primaryButton.onClick}
      >
        {primaryButton.label || t('common.submit')}
      </StyledPrimaryButton>

      {secondaryButton && (
        <StyledSecondaryButton large secondary onClick={secondaryButton.onClick}>
          {secondaryButton.label || t('common.cancel')}
        </StyledSecondaryButton>
      )}
    </StyledWrapper>
  )
}

TableFormButtons.propTypes = {
  primaryButton: PropTypes.shape({
    label: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
  }).isRequired,
  secondaryButton: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func.isRequired,
  }),
  additionalButton: PropTypes.node,
  t: PropTypes.func,
}

export default withTranslation()(TableFormButtons)
